export const environment = {
    production: true,
    baseURl : 'https://apiqa.residentiq.com',
    portal : 'https://qa-portal.residentiq.com',
    riqAzureFuncToken : 'VEDJBaQB6R5KsKR9OMDlzTz8e5gKmNWDW-_CTxII4kNhAzFuCW24BA==',
    riqAzureFuncUrl : 'https://stp-prd-functions.azurewebsites.net'
  };
  